import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-custom-footer',
  templateUrl: './custom-footer.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./custom-footer.component.scss'],
})
export class CustomFooterComponent {
  currentYear: number = new Date().getFullYear();
}
